import React, { Component } from 'react'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import TextInput from '~/Common-Objects/UI/Forms/TextInput/TextInput'
import { cn } from '~/utils/cn'

function detectUnit(value, units, fallback) {
    if (value == null || !units || !units.length) return fallback
    const asString = String(value)
    const sorted = units.slice().sort((a, b) => b.length - a.length)
    for (let i = 0; i < sorted.length; i++) {
        if (asString.endsWith(sorted[i])) return sorted[i]
    }
    return fallback
}

export default class ComponentSelect extends Component {
    constructor(props) {
        super(props)
        this.change = this.change.bind(this)
        this.changeUnits = this.changeUnits.bind(this)

        this.state = {
            hugContentsEnabled: false
        }
    }

    componentDidMount() {
        if (this.props.elementData.hugContentsEnabled) {
            this.setState({ hugContentsEnabled: true })
        }
    }

    change(thisValue) {
        var thisUnit = this.props.unit
        if (this.props.editableUnits) {
            thisUnit = detectUnit(this.props.value, this.props.editableUnits, thisUnit)
        }

        if (isNaN(thisValue) === true) {
            thisValue = this.props.value.replace(thisUnit, '')
        }
        thisValue = Number(thisValue)

        var finalVal = thisValue + thisUnit
        let maxVal = 100
        if (this.props?.elementData?.maxValue && !isNaN(this.props?.elementData?.maxValue))
            maxVal = this.props.elementData.maxValue
        if (thisUnit == '%' && thisValue > maxVal) {
            finalVal = maxVal + '' + thisUnit
        }

        this.props.updateVal(this.props.path, finalVal)
    }

    changeUnits(forcedNextUnitType) {
        var thisVal = this.props.value
        var origUnit = this.props.unit
        let nextUnit = origUnit

        if (this.props.editableUnits) {
            origUnit = detectUnit(thisVal, this.props.editableUnits, origUnit)
        }

        if (origUnit == 'auto') {
            thisVal = '100'
        }
        var nextVal = Number(thisVal.replace(origUnit, ''))

        if (forcedNextUnitType) {
            nextUnit = forcedNextUnitType
        } else {
            for (var x in this.props.editableUnits) {
                x = Number(x)
                if (this.props.editableUnits[x] === origUnit) {
                    if (x < this.props.editableUnits.length - 1) {
                        nextUnit = this.props.editableUnits[x + 1]
                        break
                    } else {
                        nextUnit = this.props.editableUnits[0]
                        break
                    }
                }
            }
        }

        if (nextUnit == '%' && nextVal >= 100) {
            nextVal = 99
        }
        if (nextUnit == '%' && nextVal <= 0) {
            nextVal = 1
        }
        if (nextUnit == 'auto') {
            nextVal = ''
        }
        if (nextUnit == 'full') {
            nextVal = '100'
            nextUnit = '%'
        }
        if (nextUnit == 'hugContents') {
            nextVal = '0'
            nextUnit = '%'
        }
        if (nextUnit == 'px') {
            if (this.props.editableDefaults && this.props.editableDefaults['px'] != null) {
                nextVal = parseInt(this.props.editableDefaults['px'])
            } else if (!this.props.elementData.showSlider) {
                nextVal = 1000
            }
        }
        if ((nextUnit == 'vh' || nextUnit == '%') && nextVal > 100) {
            nextVal = 100
        }

        nextVal = nextVal + nextUnit
        this.props.updateVal(this.props.path, nextVal)
    }
    render() {
        var thisVal = this.props.value
        var thisUnit = this.props.unit
        if (thisVal == null) thisVal = ''
        if (typeof thisVal !== 'string') thisVal = String(thisVal)

        if (isNaN(thisVal)) {
            const thisValLower = thisVal.toLowerCase()
            if (thisValLower == 'normal') {
                thisVal = '100' + thisUnit
            } else if (thisValLower == 'slight') {
                thisVal = '125' + thisUnit
            } else if (thisValLower == '1 1/2 spacing') {
                thisVal = '150' + thisUnit
            } else if (thisValLower == 'double') {
                thisVal = '200' + thisUnit
            }
        }

        if (this.props.editableUnits) {
            thisUnit = detectUnit(thisVal, this.props.editableUnits, thisUnit)
        }
        var readOnly = true
        var thisUnitTxt = thisUnit
        if (thisUnit == 'auto') {
            readOnly = true
            thisUnitTxt = 'Change'
        }
        if (thisUnit != 'auto') {
            readOnly = false
            thisVal = thisVal.replace(thisUnit, '')
        }

        var style = {}
        if (this.props.elementData.optionFullWidth) style = { width: '100%' }

        let hasSelectableUnits = false
        let holderClassName = 'dd_inputTool'
        let editableUnitsData = []
        let holderStyle = {}
        if (this.props.editableUnits && this.props.editableUnits.length > 1) {
            hasSelectableUnits = true
            if (this.props.editableUnits.indexOf('full') === -1 && this.props.editableUnits.indexOf('%') > -1) {
                editableUnitsData.push({ label: 'Full', value: 'full' })
            }
            if (this.state.hugContentsEnabled) {
                editableUnitsData.push({ label: 'Hug Contents', value: 'hugContents' })
            }

            this.props.editableUnits.forEach((u) => {
                let label = u
                if (!this.props.elementData.rawUnitLabels) {
                    if (u === '%') label = 'Percentage'
                    if (u === 'px') label = 'Fixed'
                    if (u === 'auto') label = 'Auto'
                    if (u === 'full') label = 'Full'
                    if (u === 'hugContents') label = 'Hug Contents'
                }
                editableUnitsData.push({ label: label, value: u })
            })

            if (thisUnit == '%' && thisVal + '' === '100') {
                thisUnit = 'full'
            } else if (this.state.hugContentsEnabled && thisUnit == '%' && thisVal + '' === '0') {
                thisUnit = 'hugContents'
            } else {
                holderClassName += ' quickFlex'
                holderStyle.justifyContent = 'space-between'
                holderStyle.gap = '12px'
            }
        }

        const rightIcon = <span style={{ color: '#000000' }}>{thisUnitTxt}</span>
        const showSlider = !!this.props.elementData.showSlider
        const numericVal = thisVal === '' || thisVal == null || isNaN(Number(thisVal)) ? 0 : Number(thisVal)
        let sliderMin = this.props.elementData.sliderMin != null ? Number(this.props.elementData.sliderMin) : 0
        let sliderMax = this.props.elementData.sliderMax != null ? Number(this.props.elementData.sliderMax) : 1000
        let sliderStep = 1
        if (thisUnit === 'vh' || thisUnit === '%') {
            sliderMax = 100
        } else if (thisUnit === 'em' || thisUnit === 'rem') {
            sliderMax = 50
            sliderStep = 0.1
        }

        return (
            <div
                className={cn(
                    'dndEditorv2-dd_toolHolder',
                    this.props.elementData.optionHalfWidth && 'dndEditorv2-dd_toolHolder-half'
                )}
                style={style}
            >
                <div style={{ width: '100%' }}>
                    {showSlider && (
                        <>
                            <div className='txtInput_label dndEditorv2-sliderLabel'>
                                <span className='dndEditorv2-sliderLabel-text'>
                                    {this.props.title}
                                </span>
                            </div>
                            <div className='dndEditorv2-sliderRow'>
                                <input
                                    type='range'
                                    className='dndEditorv2-unitSlider'
                                    min={sliderMin}
                                    max={sliderMax}
                                    step={sliderStep}
                                    value={Math.min(sliderMax, Math.max(sliderMin, numericVal))}
                                    onChange={(event) => {
                                        this.change(event.currentTarget.value)
                                    }}
                                />
                                <TextInput
                                    outerStyle={{ width: 64, flex: '0 0 64px' }}
                                    label={''}
                                    value={thisVal}
                                    className={this.props.className}
                                    type='number'
                                    onChange={(event) => {
                                        this.change(event.currentTarget.value)
                                    }}
                                    readOnly={readOnly}
                                />
                                {hasSelectableUnits && (
                                    <div className='dndEditorv2-sliderUnitSelect'>
                                        <Select
                                            label={''}
                                            value={thisUnit}
                                            onChange={(event) => {
                                                this.changeUnits(event?.target?.value)
                                            }}
                                            data={editableUnitsData}
                                            className='dd_inputTool_select'
                                            usePortal={true}
                                        />
                                    </div>
                                )}
                            </div>
                        </>
                    )}
                    {!showSlider && hasSelectableUnits && (
                        <div className='txtInput_label'>
                            {this.props.title}
                        </div>
                    )}
                    {!showSlider && (
                        <div className={holderClassName} style={holderStyle}>
                            {hasSelectableUnits && (
                                <div style={{ flex: 1 }}>
                                    <Select
                                        label={''}
                                        value={thisUnit}
                                        onChange={(event) => {
                                            this.changeUnits(event?.target?.value)
                                        }}
                                        data={editableUnitsData}
                                        className='dd_inputTool_select'
                                        usePortal={true}
                                    />
                                </div>
                            )}
                            {(!hasSelectableUnits ||
                                (thisUnit !== 'full' && thisUnit !== 'auto' && thisUnit != 'hugContents')) && (
                                <TextInput
                                    outerStyle={{ flex: 1 }}
                                    label={hasSelectableUnits ? '' : this.props.title}
                                    value={thisVal}
                                    className={this.props.className}
                                    type='number'
                                    onChange={(event) => {
                                        this.change(event.currentTarget.value)
                                    }}
                                    readOnly={readOnly}
                                    iconRight={rightIcon}
                                />
                            )}
                        </div>
                    )}
                </div>
            </div>
        )
    }
}
